import React from 'react';
import { InstancesTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import type { Instance } from '@v2/types';

const columns: Column<Instance>[] = [
  {
    key: 'id',
    header: 'Instance',
    sortKey: 'id',
    render: row => (
      <div className={styles.instanceCell}>
        <span className={styles.instanceName}>{row.name ?? '-'}</span>
        <span className={styles.instanceId}>{row.id}</span>
      </div>
    ),
  },
  {
    key: 'practiceName',
    header: 'Practice Name',
    render: row => <span className={styles.name}>{row.practice?.name ?? '-'}</span>,
  },
  {
    key: 'pims',
    header: 'PIMS',
    render: row => (
      <span className={styles.pimsText}>{row.practice?.pimsInfo?.displayName ?? '-'}</span>
    ),
  },
  {
    key: 'pimsVersion',
    header: 'PIMS Version',
    render: row => (
      <span className={styles.pimsText}>{row.practice?.pimsVersionInfo?.version ?? '-'}</span>
    ),
  },
];

const InstancesTable: React.FC<InstancesTableProps> = ({
  instances,
  loading,
  error,
  onSelectInstance,
  selectedInstanceId: _selectedInstanceId,
  selectedInstanceIds,
  onSelectionChange,
  sortConfig,
  onSortChange,
  search,
  onSearchChange,
  searchPlaceholder,
  filterSlot,
}) => (
  <Table<Instance>
    columns={columns}
    data={instances}
    keyExtractor={instance => instance.id}
    loading={loading}
    error={error}
    emptyMessage="No instances found."
    onRowClick={onSelectInstance}
    selectable
    selectedKeys={selectedInstanceIds}
    onSelectionChange={onSelectionChange}
    sortConfig={sortConfig ?? null}
    onSortChange={onSortChange}
    search={search}
    onSearchChange={onSearchChange}
    searchPlaceholder={searchPlaceholder}
    filterSlot={filterSlot}
  />
);

export default InstancesTable;
